<template>
  <div class="benefits">
    <div ref="benefit" v-for="(benefit, key, index) in benefits" :key="key">
      <cost-efficient
        v-if="key === 'cost-efficient'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <easy
        v-else-if="key === 'easy'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <environmental
        v-else-if="key === 'environmental'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <fast
        v-else-if="key === 'fast'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <reliable
        v-else-if="key === 'reliable'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <secure
        v-else-if="key === 'secure'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
      <technology
        v-else-if="key === 'technology'"
        :benefit="benefit"
        :active="index === activeIndex"
      />
    </div>
    <benefits-nav
      :count="benefitsCount"
      :activeIndex="activeIndex"
      :label="label"
    />
    <bottom-nav
      :absolute="false"
      :prev="{ to: '/intro', label: 'Product information' }"
      :next="{ to: '/configurator', label: 'Configurator' }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CostEfficient from '@/components/templates/CostEfficient';
import Easy from '@/components/templates/Easy';
import Environmental from '@/components/templates/Environmental';
import Fast from '@/components/templates/Fast';
import Reliable from '@/components/templates/Reliable';
import Secure from '@/components/templates/Secure';
import Technology from '@/components/templates/Technology';
import BenefitsNav from '@/components/BenefitsNav';
import BottomNav from '@/components/BottomNav';

export default {
  name: 'Benefits',
  data() {
    return {
      activeIndex: 0,
      scrollListener: null,
    };
  },
  components: {
    CostEfficient,
    Easy,
    Environmental,
    Fast,
    Reliable,
    Secure,
    Technology,
    BenefitsNav,
    BottomNav,
  },
  computed: {
    ...mapGetters(['benefits']),
    benefitsCount() {
      return this.benefits && Object.keys(this.benefits).length;
    },
    label() {
      return this.benefits ? Object.values(this.benefits)[this.activeIndex].label : '';
    },
  },
  mounted() {
    this.checkActive();
    this.scrollListener = window.addEventListener('scroll', this.checkActive);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener);
  },
  methods: {
    ...mapActions(['setDark']),
    checkActive() {
      const height = window.innerHeight;
      if (!this.benefits) {
        return;
      }
      this.$refs.benefit.forEach((benefitEl, index) => {
        const rect = benefitEl.getBoundingClientRect();
        if (rect.top < height / 2 && rect.bottom > height / 2) {
          this.activeIndex = index;
        }
        if (rect.top < 50 && rect.bottom > 50) {
          this.setDark(Object.values(this.benefits)[index].dark);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.benefits {
  overflow: hidden;
  margin-bottom: $menubar-height;
}
</style>



// WEBPACK FOOTER //
// src/views/Benefits.vue